import styled from 'styled-components'
import { TituloH1 as TituloPrincipal, Descricao } from '../../../../components/TituloSorriso/styles'
import { colorBrandPrimary } from '../../../../global.style'
import { media } from '../../../../layouts/utils'

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
`
export const Container = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, -50%);
`

export const CupomContainer = styled.div`
  ${media.desktop`
    width: 90vw;
    padding: 25px;
    height: fit-content;
  `}
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; 
  height: 290px;
  background-color: ${(props) => props.cor};
  border-radius: 15px;
  padding: 35px;
  width: 600px;
`

export const Title = styled(TituloPrincipal)`
  ${media.desktop`
    text-align: center;
  `}
  text-align: center;
  padding: 0;
  padding-bottom: 10px;
  text-align: left;
  line-height: 40px;
  color: ${colorBrandPrimary.turquoise}
`

export const Text = styled(Descricao)`
  ${media.desktop`
    text-align: center;
  `}
  ${media.phone`
    padding-bottom: 0px;
  `}
  padding: 0;
  padding-bottom: 10px;
  text-align: left;
  color: #fff;
`

export const InputContainer = styled.div`
  position: relative;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-width: 2px; 
  border-bottom-color: ${colorBrandPrimary.turquoise};
  border-bottom-style: solid;
  height: 60px;
  width: 100%;
  background-color: #fff;
  padding: 10px;
`

export const Input = styled.input`
  height: 100%;
  width: 100%;
  border: none;
  padding-left: 15px;
`

export const FooterContainer = styled.div`
  ${media.desktop`
    display: block;
    text-align: center;
    > *:first-child {
      margin: 0px !important;
    }
  `}
  display: flex;
  justify-content: flex-end;
  align-items: end;
  width: 100%;
  padding-top: 20px;
  > *:first-child {
    margin-right: 20px;
  }
`

export const Link = styled.a`
  cursor: pointer;
  padding-top: 17px;
  padding-bottom: 5px;
  box-sizing: border-box;
  background-repeat: no-repeat;
  background-position: 0px 100%, 100% 100%;
  background-size: 0 2px,100% 2px;
  font-family: Galano Grotesque Alt;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.3em;
  position: relative;
  text-decoration: none;
  transition: background-size 0.2s ease-in-out 0s;
  width: max-content;
  color: #fff !important;
  background-image: linear-gradient(120deg, ${colorBrandPrimary.darkMarine} 0%, ${colorBrandPrimary.darkMarine} 100%),linear-gradient(120deg, ${colorBrandPrimary.turquoise} 0%, ${colorBrandPrimary.turquoise} 100%);
  &:hover {
    background-size: 100% 2px,100% 2px;
  }
`

export const OfferImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  max-width: 200px;
  padding-top: 25px;
`
export const OfferImage = styled.img`
  width: 100%;
`

export const ModalContent = styled.div`
`
export const ModalHeader = styled.div`
  display: flex;
  align-content: center;
  justify-content: flex-end;
  width: 100%;
  height: 40px;
`
export const ButtonClose = styled.img`
  padding-top: 5px;
  width: 25px;
  height: 30px;
  cursor: pointer;
`

export const TextError = styled.p`
  align-self: flex-start;
  color: #fff;
  padding-top: 5px;
  font-weight: bold;
`